import {Injectable} from '@angular/core';
import {
    GroupInspectionValuesService,
    SubgroupChangeOrderDto,
} from '@core/interfaces/engin/mobile-admin/group-inspection-values';
import {Observable} from 'rxjs';
import {GroupInspectionValuesApi} from '@core/backend/engin/api/mobile-admin/group-inspection-values.api';

@Injectable()
export class GroupInspectionValuesServiceImpl extends GroupInspectionValuesService {
    constructor(private api: GroupInspectionValuesApi) {
        super();
    }

    deleteSubGroupInspection(subGroupId: number): Observable<void> {
        return this.api.deleteSubGroupInspection(subGroupId);
    }
    changeSubgroupContentOrder(subGroupId: number, reqBody: SubgroupChangeOrderDto): Observable<void> {
        return this.api.changeSubgroupContentOrder(subGroupId, reqBody);
    }
}
